import clsx from 'clsx'
import { Chrome, PartyPopper, Smartphone, Palette, Instagram, Building, Search, DollarSign, Megaphone, Star, ShoppingBag, BookOpen, LayoutGrid } from 'lucide-react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { memo } from 'react'

const categoryIcon = (category) => {
  if (category === 'All') {
    return <LayoutGrid className="size-5" />
  }
  if (category === 'Mobile Web Design') {
    return <Smartphone className="size-5" />
  }
  if (category === 'Google') {
    return <Chrome className="size-5"/>
  }
  if (category === 'Design') {
    return <Palette className="size-5" />
  }
  if (category === 'Social Media') {
    return <Instagram className="size-5" />
  }
  if (category === 'Small Business') {
    return <Building className="size-5" />
  }
  if (category === 'SEO') {
    return <Search className="size-5" />
  }
  if (category === 'eCommerce') {
    return <DollarSign className="size-5" />
  }
  if (category === 'Marketing') {
    return <Megaphone className="size-5" />
  }
  if (category === 'BigCommerce') {
    return <Star className="size-5" />
  }
  if (category === 'Shopify') {
    return <ShoppingBag className="size-5" />
  }
  if (category === "Buyer's Guides") {
    return <BookOpen className="size-5" />
  }
  if (category === 'Events') {
    return <PartyPopper className="size-5"/>
  }
}

const Sidebar = ({ categories, categoriesWithPostCounts }) => {
  const router = useRouter()
  
  // Calculate total post count from all categories
  const totalPostCount = categoriesWithPostCounts.reduce((sum, cat) => sum + (cat.postCount || 0), 0)
  
  const isAllActive =
    router.pathname === '/resources' ||
    router.asPath === '/resources' ||
    router.asPath.startsWith('/resources?page=')
  
  return (
    <aside className="sticky top-24 h-max w-full self-start">
      <div className="rounded-lg border bg-white shadow-sm">
        <div className="border-b px-4 py-3">
          <h2 className="text-sm font-semibold tracking-wide text-neutral-800">Browse categories</h2>
        </div>
        <nav className="flex max-h-[70vh] flex-col overflow-auto px-2 py-2">
          {/* All Categories Link */}
          <Link
            href="/resources"
            className={clsx(
              'relative flex items-center justify-between gap-2 rounded-md px-3 py-2 text-sm hover:bg-neutral-50',
              isAllActive && 'bg-neutral-100',
            )}
          >
            <span className="flex items-center gap-2 font-medium text-neutral-800">
              {categoryIcon('All')}
              All
            </span>
            <span className="ml-2 shrink-0 rounded-full bg-neutral-100 px-2 py-0.5 text-xs text-neutral-600">
              {totalPostCount}
            </span>
          </Link>
          
          {/* Individual Categories */}
          {categories
          .sort(
            (a, b) =>
              categoriesWithPostCounts.find((cat) => cat._id === b._id)
                .postCount -
              categoriesWithPostCounts.find((cat) => cat._id === a._id)
                .postCount,
          )
          .map((category) => {
            return (
              <Link
                key={category._id}
                className={clsx(
                  'relative flex items-center justify-between gap-2 rounded-md px-3 py-2 text-sm hover:bg-neutral-50',
                  router.asPath === `/resources/category/${category.slug.current}` &&
                    'bg-neutral-100',
                )}
                href={`/resources/category/${category.slug.current}`}
              >
                <span className="flex items-center gap-2 font-medium text-neutral-800">
                  {categoryIcon(category.title)}
                  {category.title}
                </span>
                <span className="ml-2 shrink-0 rounded-full bg-neutral-100 px-2 py-0.5 text-xs text-neutral-600">
                  {categoriesWithPostCounts.find((cat) => cat._id === category._id)?.postCount ?? 0}
                </span>
              </Link>
            )
          })}
        </nav>
      </div>
    </aside>
  )
}

export default memo(Sidebar)
